import type { InfoBadgeType } from "./config/infoBadgeConfig";

// TODO: Normalize partner and topic at a higher level in our SDK
export const getOfferInfoBadgeType = (partner: string, topic?: string): InfoBadgeType | null => {
    if (partner.toUpperCase() === "VERIZON" && topic?.toUpperCase() === "VERIZON_LOYALTY_CREDIT") {
        return "verizonLoyalty";
    }
    // Add conditions for other partners/topics here if any in the future
    return null;
};
